import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../ui/CollapsiblePannel/Collapsible";
import { useWheelBrandOptions } from "./useWheelBrandOptions";
import { useWheelBrands } from "./useWheelBrands";

const id = "dealer-wheel-brands-panel";

export const WheelBrand: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, { toggle }] = useWheelBrands();
  const options = useWheelBrandOptions();

  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.wheelBrand")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ brand, checked, count }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={brand}
        >
          <Checkbox
            onChange={(): void => {
              toggle([brand]);
            }}
            checked={checked}
            disabled={count === 0}
            name="brand"
          />
          <span className="flex-1">{brand}</span>
        </label>
      ))}
    </Collapsible>
  );
};
